import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MatMenuModule } from '@angular/material/menu';

import { PostCommentsPageRoutingModule } from './post-comments-routing.module';

import { PostCommentsPage } from './post-comments.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatMenuModule,
    PostCommentsPageRoutingModule,
    ReactiveFormsModule
  ],
  declarations: [PostCommentsPage]
})
export class PostCommentsPageModule {}
